import { render, staticRenderFns } from "./beenCourse.vue?vue&type=template&id=7b529806&"
import script from "./beenCourse.vue?vue&type=script&lang=js&"
export * from "./beenCourse.vue?vue&type=script&lang=js&"
import style0 from "./beenCourse.vue?vue&type=style&index=0&id=7b529806&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b529806')) {
      api.createRecord('7b529806', component.options)
    } else {
      api.reload('7b529806', component.options)
    }
    module.hot.accept("./beenCourse.vue?vue&type=template&id=7b529806&", function () {
      api.rerender('7b529806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lesson/component/beenCourse.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/lesson/component/beenCourse.vue
// module id = q3jF
// module chunks = 0